var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-flatpickr-component",
    _vm._g(
      {
        staticClass: "vuestic-date-picker",
        class: { "has-value": _vm.valueProxy && _vm.valueProxy.length },
        attrs: { config: _vm.fullConfig },
        model: {
          value: _vm.valueProxy,
          callback: function ($$v) {
            _vm.valueProxy = $$v
          },
          expression: "valueProxy",
        },
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }